"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _nanoid = _interopRequireDefault(require("nanoid"));

var _ArrowLeft = _interopRequireDefault(require("@paprika/icon/lib/ArrowLeft"));

var _ArrowRight = _interopRequireDefault(require("@paprika/icon/lib/ArrowRight"));

var _button = _interopRequireDefault(require("@paprika/button"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _useI18n = _interopRequireDefault(require("@paprika/l10n/lib/useI18n"));

var _ShortcutPanel = require("./ShortcutPanel.styles");

var propTypes = {
  date: _propTypes["default"].instanceOf(_moment["default"]).isRequired,

  /** If the ShortcutPanel is set to be visible */
  isVisible: _propTypes["default"].bool.isRequired,

  /** Function to call when cancel button is clicked. */
  onCancel: _propTypes["default"].func.isRequired,

  /** Function to call when primary button is clicked. */
  onConfirm: _propTypes["default"].func.isRequired
};

var _StyledDiv = (0, _styledComponents["default"])("div").withConfig({
  displayName: "ShortcutPanel___StyledDiv",
  componentId: "sc-1t2odr5-0"
})(["", ""], _ShortcutPanel.optionWrapperStyles);

var _StyledLabel = (0, _styledComponents["default"])("label").withConfig({
  displayName: "ShortcutPanel___StyledLabel",
  componentId: "sc-1t2odr5-1"
})(["", ""], _ShortcutPanel.labelStyles);

var _StyledDiv2 = (0, _styledComponents["default"])("div").withConfig({
  displayName: "ShortcutPanel___StyledDiv2",
  componentId: "sc-1t2odr5-2"
})(["", ""], _ShortcutPanel.optionWrapperStyles);

var _StyledLabel2 = (0, _styledComponents["default"])("label").withConfig({
  displayName: "ShortcutPanel___StyledLabel2",
  componentId: "sc-1t2odr5-3"
})(["", ""], _ShortcutPanel.labelStyles);

var _StyledDiv3 = (0, _styledComponents["default"])("div").withConfig({
  displayName: "ShortcutPanel___StyledDiv3",
  componentId: "sc-1t2odr5-4"
})(["", ""], _ShortcutPanel.containerStyles);

var _StyledDiv4 = (0, _styledComponents["default"])("div").withConfig({
  displayName: "ShortcutPanel___StyledDiv4",
  componentId: "sc-1t2odr5-5"
})(["", ""], _ShortcutPanel.panelContentStyles);

var _StyledDiv5 = (0, _styledComponents["default"])("div").withConfig({
  displayName: "ShortcutPanel___StyledDiv5",
  componentId: "sc-1t2odr5-6"
})(["", ""], _ShortcutPanel.listStyles);

var _StyledDiv6 = (0, _styledComponents["default"])("div").withConfig({
  displayName: "ShortcutPanel___StyledDiv6",
  componentId: "sc-1t2odr5-7"
})(["", ""], _ShortcutPanel.columnHeaderStyles);

var _StyledDiv7 = (0, _styledComponents["default"])("div").withConfig({
  displayName: "ShortcutPanel___StyledDiv7",
  componentId: "sc-1t2odr5-8"
})(["", ""], _ShortcutPanel.yearListStyles);

var _StyledDiv8 = (0, _styledComponents["default"])("div").withConfig({
  displayName: "ShortcutPanel___StyledDiv8",
  componentId: "sc-1t2odr5-9"
})(["", ""], _ShortcutPanel.columnHeaderStyles);

var _StyledDiv9 = (0, _styledComponents["default"])("div").withConfig({
  displayName: "ShortcutPanel___StyledDiv9",
  componentId: "sc-1t2odr5-10"
})(["", ""], _ShortcutPanel.actionBarStyles);

function ShortcutPanel(props) {
  var uniqId = _react["default"].useMemo(function () {
    return (0, _nanoid["default"])();
  }, []);

  var date = props.date,
      isVisible = props.isVisible,
      onCancel = props.onCancel,
      onConfirm = props.onConfirm;

  var _React$useState = _react["default"].useState(0),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      pageIndex = _React$useState2[0],
      setPageIndex = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(date.month()),
      _React$useState4 = (0, _slicedToArray2["default"])(_React$useState3, 2),
      selectedMonth = _React$useState4[0],
      setSelectedMonth = _React$useState4[1];

  var _React$useState5 = _react["default"].useState(date.year()),
      _React$useState6 = (0, _slicedToArray2["default"])(_React$useState5, 2),
      selectedyear = _React$useState6[0],
      setSelectedYear = _React$useState6[1];

  var I18n = (0, _useI18n["default"])();

  function handleChange(event) {
    var name = event.target.name;
    var value = event.target.value;

    switch (name) {
      case "month":
        setSelectedMonth(value * 1);
        break;

      case "year":
        setSelectedYear(value * 1);
        break;

      default:
        break;
    }
  }

  function handleConfirm() {
    onConfirm({
      month: selectedMonth,
      year: selectedyear
    });
  }

  function renderMonthList() {
    return _moment["default"].monthsShort().map(function (month, monthIndex) {
      return /*#__PURE__*/_react["default"].createElement(_StyledDiv, {
        key: month
      }, /*#__PURE__*/_react["default"].createElement("input", {
        type: "radio",
        name: "month",
        id: "".concat(uniqId, "-").concat(monthIndex),
        value: monthIndex,
        defaultChecked: monthIndex === selectedMonth,
        onChange: handleChange
      }), /*#__PURE__*/_react["default"].createElement(_StyledLabel, {
        htmlFor: "".concat(uniqId, "-").concat(monthIndex),
        isSelected: monthIndex === selectedMonth
      }, month));
    });
  }

  function renderYearList() {
    var SELECTED_YEAR_POSITION = 5;
    var YEARS_SHOWN = 12;
    var currentYear = date.year();
    var list = [];

    for (var i = 0; i < YEARS_SHOWN; i++) {
      list.push(currentYear * 1 + pageIndex * YEARS_SHOWN + (i - SELECTED_YEAR_POSITION));
    }

    return list.map(function (year) {
      return /*#__PURE__*/_react["default"].createElement(_StyledDiv2, {
        key: year
      }, /*#__PURE__*/_react["default"].createElement("input", {
        type: "radio",
        name: "year",
        id: "".concat(uniqId, "-").concat(year),
        value: year,
        defaultChecked: year === selectedyear,
        onChange: handleChange
      }), /*#__PURE__*/_react["default"].createElement(_StyledLabel2, {
        htmlFor: "".concat(uniqId, "-").concat(year),
        isSelected: year === selectedyear
      }, year));
    });
  }

  function handleClickPrev() {
    setPageIndex(pageIndex - 1);
  }

  function handleClickNext() {
    setPageIndex(pageIndex + 1);
  }

  return /*#__PURE__*/_react["default"].createElement(_StyledDiv3, {
    "data-pka-anchor": "calendar.shortcut",
    isVisible: isVisible
  }, /*#__PURE__*/_react["default"].createElement(_StyledDiv4, null, /*#__PURE__*/_react["default"].createElement(_StyledDiv5, null, /*#__PURE__*/_react["default"].createElement(_StyledDiv6, null, I18n.t("calendar.month")), /*#__PURE__*/_react["default"].createElement("div", {
    role: "group"
  }, renderMonthList())), /*#__PURE__*/_react["default"].createElement(_StyledDiv7, null, /*#__PURE__*/_react["default"].createElement(_StyledDiv8, {
    isYear: true
  }, /*#__PURE__*/_react["default"].createElement(_button["default"].Icon, {
    isSemantic: false,
    onClick: handleClickPrev,
    kind: _button["default"].Icon.types.kind.MINOR,
    size: _button["default"].Icon.types.size.SMALL
  }, /*#__PURE__*/_react["default"].createElement(_ArrowLeft["default"], {
    color: _tokens["default"].textColor.icon
  })), I18n.t("calendar.year"), /*#__PURE__*/_react["default"].createElement(_button["default"].Icon, {
    isSemantic: false,
    onClick: handleClickNext,
    kind: _button["default"].Icon.types.kind.MINOR,
    size: _button["default"].Icon.types.size.SMALL
  }, /*#__PURE__*/_react["default"].createElement(_ArrowRight["default"], {
    color: _tokens["default"].textColor.icon
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    role: "group"
  }, renderYearList()))), /*#__PURE__*/_react["default"].createElement(_StyledDiv9, null, /*#__PURE__*/_react["default"].createElement(_button["default"], {
    isSemantic: false,
    kind: _button["default"].types.kind.PRIMARY,
    onClick: handleConfirm,
    size: _button["default"].types.size.SMALL,
    "data-pka-anchor": "calendar.apply"
  }, I18n.t("actions.apply")), /*#__PURE__*/_react["default"].createElement(_button["default"], {
    isSemantic: false,
    kind: _button["default"].types.kind.MINOR,
    onClick: onCancel,
    size: _button["default"].types.size.SMALL,
    "data-pka-anchor": "calendar.cancel"
  }, I18n.t("actions.cancel"))));
}

ShortcutPanel.propTypes = propTypes;
ShortcutPanel.displayName = "Calendar.ShortcutPanel";
var _default = ShortcutPanel;
exports["default"] = _default;
//# sourceMappingURL=ShortcutPanel.js.map